import styled from '@emotion/styled';
import { Variables } from '../../base';

export const Container = styled.div`
    position: relative;
    width: 100%;
`;

export const TextareaWrapper = styled.div`
    position: relative;
    width: 100%;
`;

export const Textarea = styled.textarea`
    width: 100%;
    min-height: 40px;
    max-height: 240px;
    padding: 8px 12px;
    
    font-size: 16px;
    line-height: 1.5;
    
    border: 1px solid ${Variables.Colors.nx8};
    border-radius: ${Variables.Rounded.small};
    background-color: ${Variables.Colors.white};
    color: ${Variables.Colors.n100};
    
    resize: none;
    overflow-y: auto;
    
    transition: ${Variables.transition};
    
    &:focus {
        outline: none;
        border-color: ${Variables.Colors.b100};
        box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.24);
    }
    
    &:disabled {
        background-color: ${Variables.Colors.n15};
        color: ${Variables.Colors.n50};
        cursor: not-allowed;
    }
    
    &::placeholder {
        color: ${Variables.Colors.n15};
        font-size: 14px;
    }
`;

export const LoadingOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    
    display: flex;
    align-items: center;
    justify-content: center;
    
    background-color: ${Variables.Colors.white}cc;
    border-radius: 4px;
    
    pointer-events: none;
`;

export const Dropdown = styled.div`
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    width: 100%;
    
    max-height: 300px;
    overflow-y: auto;
    
    background-color: ${Variables.Colors.white};
    border: 1px solid ${Variables.Colors.n30};
    border-radius: 4px;
    box-shadow: ${Variables.Shadows.small};
    
    z-index: 10000;
    
    /* Custom scrollbar */
    &::-webkit-scrollbar {
        width: 8px;
    }
    
    &::-webkit-scrollbar-track {
        background: ${Variables.Colors.n15};
    }
    
    &::-webkit-scrollbar-thumb {
        background: ${Variables.Colors.n30};
        border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
        background: ${Variables.Colors.n50};
    }
`;

export const LoadingMessage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    
    font-size: 14px;
    color: ${Variables.Colors.n70};
`;

interface ISearchResultProps {
    isSelected?: boolean;
}

export const SearchResult = styled.div<ISearchResultProps>`
    display: flex;
    flex-direction: column;
    padding: 8px 12px;
    
    cursor: pointer;
    background-color: ${props => props.isSelected ? 'rgba(33, 150, 243, 0.24)' : Variables.Colors.white};
    border-bottom: 1px solid ${Variables.Colors.n15};
    
    transition: background-color 0.15s;
    
    &:last-child {
        border-bottom: none;
    }
    
    &:hover {
        background-color: ${Variables.Colors.n15_24};
    }
    
    &:active {
        background-color: ${Variables.Colors.n15_48};
    }
`;

export const SearchResultRow = styled.div`
    display: flex;
    gap: 8px;
    
    font-size: 12px;
    color: ${Variables.Colors.n70};
    
    &:not(:last-child) {
        margin-bottom: 4px;
    }
`;

export const SearchResultCell = styled.div`
    display: flex;
    align-items: center;
    
    &:first-of-type {
        min-width: 80px;
    }
    
    &:last-child {
        margin-left: auto;
        font-weight: 500;
    }
`;

export const ErrorContainer = styled.div`
    margin-top: 8px;
    padding: 12px;
    
    background-color: ${Variables.Colors.r10};
    border: 1px solid ${Variables.Colors.r30};
    border-radius: 4px;
    
    animation: slideIn 0.2s ease-out;
    
    @keyframes slideIn {
        from {
            opacity: 0;
            transform: translateY(-4px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

export const ErrorTitle = styled.div`
    margin-bottom: 8px;
    
    font-size: 14px;
    font-weight: 600;
    color: ${Variables.Colors.r50};
`;

export const ErrorList = styled.ul`
    margin: 0;
    padding: 0 0 0 20px;
    
    list-style-type: disc;
`;

export const ErrorItem = styled.li`
    margin-bottom: 4px;
    
    font-size: 13px;
    line-height: 1.4;
    color: ${Variables.Colors.r50};
    
    &:last-child {
        margin-bottom: 0;
    }
    
    code {
        padding: 2px 4px;
        background-color: ${Variables.Colors.r20};
        border-radius: 2px;
        font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
        font-size: 12px;
    }
`;

